@import "~katex/dist/katex.min.css";
@import "./katex-fonts.css";

/**
 * Wrap expression
 */
.katex 
{
  white-space: normal !important;
}